



// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { collection, addDoc, Timestamp } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import './FloatingActions.css';
// import { FirestoreService } from '../../firebase/firestoreService';

// const FloatingActions = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [compareCount, setCompareCount] = useState(0);
//   const [wishlistCount, setWishlistCount] = useState(0);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userId, setUserId] = useState(null);
//   const WHATSAPP_NUMBER = "8861938913";

//   // Load counts from localStorage and check login status on component mount
//   useEffect(() => {
//     const loadCounts = () => {
//       try {
//         // Get compare items
//         const compareItems = localStorage.getItem('compareItems');
//         if (compareItems) {
//           const parsedCompare = JSON.parse(compareItems);
//           setCompareCount(Array.isArray(parsedCompare) ? parsedCompare.length : 0);
//         }

//         // Get wishlist items
//         const wishlistItems = localStorage.getItem('wishListItems');
//         if (wishlistItems) {
//           const parsedWishlist = JSON.parse(wishlistItems);
//           setWishlistCount(Array.isArray(parsedWishlist) ? parsedWishlist.length : 0);
//         }

//         // Check login status
//         const authToken = localStorage.getItem('authToken');
//         setIsLoggedIn(!!authToken);
        
//         // Get user ID
//         const userData = localStorage.getItem('userData');
//         if (userData) {
//           const parsedData = JSON.parse(userData);
//           setUserId(parsedData.uid || null);
//         }
//       } catch (error) {
//         console.error("Error loading counts from localStorage:", error);
//       }
//     };

//     // Load counts initially
//     loadCounts();

//     // Set up event listeners for updates
//     window.addEventListener('compareUpdated', loadCounts);
//     window.addEventListener('wishlistUpdated', loadCounts);
//     window.addEventListener('authStateChanged', loadCounts);
    
//     // Clean up
//     return () => {
//       window.removeEventListener('compareUpdated', loadCounts);
//       window.removeEventListener('wishlistUpdated', loadCounts);
//       window.removeEventListener('authStateChanged', loadCounts);
//     };
//   }, []);

//   // Navigate to compare page
//   const handleCompareClick = async () => {
//     // If user is logged in, track this action in Firestore
//     if (isLoggedIn && userId) {
//       try {
//         await addDoc(collection(db, 'userActivities'), {
//           userId: userId,
//           action: 'navigate',
//           target: 'compare',
//           timestamp: Timestamp.now()
//         });
//       } catch (error) {
//         console.error("Error tracking compare navigation:", error);
//       }
//     }
    
//     navigate('/compare');
//   };

//   // Navigate to wishlist page
//   const handleWishlistClick = async () => {
//     // If user is logged in, track this action in Firestore
//     if (isLoggedIn && userId) {
//       try {
//         await addDoc(collection(db, 'userActivities'), {
//           userId: userId,
//           action: 'navigate',
//           target: 'wishlist',
//           timestamp: Timestamp.now()
//         });
//       } catch (error) {
//         console.error("Error tracking wishlist navigation:", error);
//       }
//     }
    
//     navigate('/wishlist');
//   };

//   // Open WhatsApp chat
//   const handleWhatsAppClick = async () => {
//     // If user is logged in, track this action in Firestore
//     if (isLoggedIn && userId) {
//       try {
//         await addDoc(collection(db, 'userActivities'), {
//           userId: userId,
//           action: 'contact',
//           method: 'whatsapp',
//           timestamp: Timestamp.now()
//         });
//       } catch (error) {
//         console.error("Error tracking WhatsApp contact:", error);
//       }
//     }
    
//     // Create pre-filled message for WhatsApp
//     const message = "Hello, I have an urgent requirement about a product. Can you help?";
//     const encodedMessage = encodeURIComponent(message);
    
//     // Open WhatsApp in a new tab
//     window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`, '_blank');
//   };

//   // Hide on compare and wishlist pages
//   if (location.pathname === '/compare' || location.pathname === '/wishlist') {
//     return null;
//   }

//   return (
//     <>
//       <div className="floating-actions">
//         <button 
//           className="floating-button compare-button" 
//           onClick={handleCompareClick}
//           title="Compare Products"
//         >
//           <div className="floating-icon-container">
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="floating-icon">
//               <path d="M10 3H3v18h7v-3H5V5h5V3zm11 0h-7v3h5v13h-5v3h7V3zM7.5 15h9v-2h-9v2zm0-4h9V9h-9v2z"/>
//             </svg>
//             {compareCount > 0 && (
//               <span className="floating-badge">{compareCount}</span>
//             )}
//           </div>
//           <span className="floating-text">Compare</span>
//         </button>

//         <button 
//           className="floating-button wishlist-button" 
//           onClick={handleWishlistClick}
//           title="Your Wishlist"
//         >
//           <div className="floating-icon-container">
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="floating-icon">
//               <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
//             </svg>
//             {wishlistCount > 0 && (
//               <span className="floating-badge">{wishlistCount}</span>
//             )}
//           </div>
//           <span className="floating-text">Wishlist</span>
//         </button>
//       </div>
      
//       {/* WhatsApp Support Button with text below */}
//       <div className="whatsapp-support">
//         <button 
//           className="whatsapp-circle-button" 
//           onClick={handleWhatsAppClick}
//           aria-label="Contact support via WhatsApp"
//         >
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
//             <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.72.045.433-.1.838z"/>
//           </svg>
//         </button>
//         <div className="whatsapp-text">
//          support
//         </div>
//       </div>
//     </>
//   );
// };

// export default FloatingActions;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import './FloatingActions.css';
import { FirestoreService } from '../../firebase/firestoreService';

const FloatingActions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [compareCount, setCompareCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const WHATSAPP_NUMBER = "8861938913";

  // Load counts from localStorage and check login status on component mount
  useEffect(() => {
    const loadCounts = () => {
      try {
        // Get compare items
        const compareItems = localStorage.getItem('compareItems');
        if (compareItems) {
          const parsedCompare = JSON.parse(compareItems);
          setCompareCount(Array.isArray(parsedCompare) ? parsedCompare.length : 0);
        }

        // Get wishlist items
        const wishlistItems = localStorage.getItem('wishListItems');
        if (wishlistItems) {
          const parsedWishlist = JSON.parse(wishlistItems);
          setWishlistCount(Array.isArray(parsedWishlist) ? parsedWishlist.length : 0);
        }

        // Check login status
        const authToken = localStorage.getItem('authToken');
        setIsLoggedIn(!!authToken);
        
        // Get user ID
        const userData = localStorage.getItem('userData');
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.uid || null);
        }
      } catch (error) {
        console.error("Error loading counts from localStorage:", error);
      }
    };

    // Load counts initially
    loadCounts();

    // Set up event listeners for updates
    window.addEventListener('compareUpdated', loadCounts);
    window.addEventListener('wishlistUpdated', loadCounts);
    window.addEventListener('authStateChanged', loadCounts);
    
    // Add scroll event listener to show/hide scroll to top button
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    
    // Clean up
    return () => {
      window.removeEventListener('compareUpdated', loadCounts);
      window.removeEventListener('wishlistUpdated', loadCounts);
      window.removeEventListener('authStateChanged', loadCounts);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Navigate to compare page
  const handleCompareClick = async () => {
    // If user is logged in, track this action in Firestore
    if (isLoggedIn && userId) {
      try {
        await addDoc(collection(db, 'userActivities'), {
          userId: userId,
          action: 'navigate',
          target: 'compare',
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking compare navigation:", error);
      }
    }
    
    navigate('/compare');
  };

  // Navigate to wishlist page
  const handleWishlistClick = async () => {
    // If user is logged in, track this action in Firestore
    if (isLoggedIn && userId) {
      try {
        await addDoc(collection(db, 'userActivities'), {
          userId: userId,
          action: 'navigate',
          target: 'wishlist',
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking wishlist navigation:", error);
      }
    }
    
    navigate('/wishlist');
  };

  // Open WhatsApp chat
  const handleWhatsAppClick = async () => {
    // If user is logged in, track this action in Firestore
    if (isLoggedIn && userId) {
      try {
        await addDoc(collection(db, 'userActivities'), {
          userId: userId,
          action: 'contact',
          method: 'whatsapp',
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking WhatsApp contact:", error);
      }
    }
    
    // Create pre-filled message for WhatsApp
    const message = "Hello, I have an urgent requirement about a product. Can you help?";
    const encodedMessage = encodeURIComponent(message);
    
    // Open WhatsApp in a new tab
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`, '_blank');
  };

  // Scroll to top function
  const scrollToTop = async () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Track scroll action if logged in
    if (isLoggedIn && userId) {
      try {
        await addDoc(collection(db, 'userActivities'), {
          userId: userId,
          action: 'scroll',
          target: 'top',
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking scroll to top:", error);
      }
    }
  };

  // Scroll to bottom function
  const scrollToBottom = async () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });

    // Track scroll action if logged in
    if (isLoggedIn && userId) {
      try {
        await addDoc(collection(db, 'userActivities'), {
          userId: userId,
          action: 'scroll',
          target: 'bottom',
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking scroll to bottom:", error);
      }
    }
  };

  // Hide on compare and wishlist pages
  if (location.pathname === '/compare' || location.pathname === '/wishlist') {
    return null;
  }

  return (
    <>
      <div className="floating-actions">
        <button 
          className="floating-button compare-button" 
          onClick={handleCompareClick}
          title="Compare Products"
        >
          <div className="floating-icon-container">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="floating-icon">
              <path d="M10 3H3v18h7v-3H5V5h5V3zm11 0h-7v3h5v13h-5v3h7V3zM7.5 15h9v-2h-9v2zm0-4h9V9h-9v2z"/>
            </svg>
            {compareCount > 0 && (
              <span className="floating-badge">{compareCount}</span>
            )}
          </div>
          <span className="floating-text">Compare</span>
        </button>

        <button 
          className="floating-button wishlist-button" 
          onClick={handleWishlistClick}
          title="Your Wishlist"
        >
          <div className="floating-icon-container">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="floating-icon">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
            {wishlistCount > 0 && (
              <span className="floating-badge">{wishlistCount}</span>
            )}
          </div>
          <span className="floating-text">Wishlist</span>
        </button>
      </div>
      
      {/* WhatsApp Support Button with text below */}
      <div className="whatsapp-support">
        <button 
          className="whatsapp-circle-button" 
          onClick={handleWhatsAppClick}
          aria-label="Contact support via WhatsApp"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.72.045.433-.1.838z"/>
          </svg>
        </button>
        <div className="whatsapp-text">
          support
        </div>
      </div>

      {/* Scroll Navigation Buttons */}
      {/* <div className="scroll-navigation">
     
        <button 
          className={`scroll-button scroll-top-button ${showScrollTop ? 'visible' : ''}`} 
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
          </svg>
        </button>
        
    
        <button 
          className="scroll-button scroll-bottom-button" 
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
          title="Scroll to bottom"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
          </svg>
        </button>
      </div> */}
    </>
  );
};

export default FloatingActions;